import axios from 'axios';
import { STORAGE_KEYS } from './constants';

const BASE_API_URL = process.env.REACT_APP_API_URL;
const BASE_API_KEY = process.env.REACT_APP_API_KEY;

interface RequestOption {
  method?: string;
  data?: any;
  params?: any;
  headers?: any;
  signal?: AbortSignal;
}

interface ApiServiceOptions {
  baseUrl?: string;
  params?: Record<string, any>;
  data?: any;
  headers?: any;
  isInternal?: boolean;
  signal?: AbortSignal;
}

const getToken = () => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  return token;
};

const makeRequest = <T>(
  urlPath: string,
  options: RequestOption,
  serviceOptions: ApiServiceOptions = {}
) => {
  const headers = serviceOptions?.headers ?? {};
  headers['Authorization'] = 'Bearer ' + getToken();
  if (serviceOptions?.isInternal) headers['x-api-key'] = BASE_API_KEY;
  const fullUrl = `${serviceOptions?.baseUrl ?? BASE_API_URL}${urlPath}`;

  return axios<T>({ ...options, ...serviceOptions, url: fullUrl, headers });
};

export const apiService = {
  makeRequest: makeRequest,
  get: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'get' }, options),
  patch: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'patch' }, options),
  post: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'post' }, options),
  put: <T = any>(urlPath: string, options: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'put' }, options),
  delete: <T = any>(urlPath: string, options?: ApiServiceOptions) =>
    makeRequest<T>(urlPath, { method: 'delete' }, options)
};
